import { render, staticRenderFns } from "./ConsultEdit.vue?vue&type=template&id=28415bd1"
import script from "./ConsultEdit.vue?vue&type=script&lang=js"
export * from "./ConsultEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports